import CrudTable from "@/components/CrudTable";

export default function GovernmentSchemes() {
  const columns = [
    { key: "scheme_name", label: "Scheme" },
    { key: "awarding_body", label: "Body", type: "badge" },
    { key: "benefit_type", label: "Benefit" },
    { key: "application_deadline", label: "Deadline" },
    { key: "status", label: "Status", type: "badge" },
    { key: "benefit_amount", label: "Benefit ₹", type: "currency" },
    { key: "remarks", label: "Remarks" },
  ];
  const fields = [
    { key: "scheme_name", label: "Scheme Name", type: "text", required: true, full: true },
    { key: "awarding_body", label: "Awarding Body", type: "select", options: ["Central", "State", "MSME", "Startup India", "Other"], required: true },
    { key: "benefit_type", label: "Benefit Type", type: "select", options: ["Subsidy", "Incentive", "Grant", "Tax Benefit", "Loan Support"], required: true },
    { key: "eligibility_notes", label: "Eligibility Notes", type: "textarea", full: true },
    { key: "application_deadline", label: "Application Deadline", type: "date" },
    { key: "status", label: "Status", type: "select", options: ["Researching", "Applied", "Under Review", "Approved", "Disbursed", "Rejected"], required: true },
    { key: "benefit_amount", label: "Benefit Amount (₹)", type: "number" },
    { key: "remarks", label: "Remarks", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="scheme" endpoint="schemes"
      title="Government Schemes & Benefits" subtitle="A proactive tracker for which MSME / aesthetic-industry schemes to pursue and whether the benefit is actually being received."
      addLabel="Add Scheme" columns={columns} fields={fields}
      defaults={{ status: "Researching" }}
    />
  );
}
